import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('TemplateFooter')
export default class TemplateFooter {
  constructor() {
    this.order = undefined;
    this.buttonText = undefined;
    this.buttonCss = undefined;
    this.buttonLink = undefined;
  }

  @JsonProperty('order')
  public order?: number;

  @JsonProperty('button_text')
  public buttonText?: string;

  @JsonProperty('button_css')
  public buttonCss?: string;

  @JsonProperty('button_link')
  public buttonLink?: string;
}
